import {useQuery} from "@tanstack/react-query";
import {readAccountContactListApi} from "../../../../../api/correspondent/CorresspondentApi";

import {BasicSearchType} from "../../../../../types/common/basic";

type Props = {
    searchData: BasicSearchType & { accountId: string };
};

/**
 * 고객 연락처 정보
 * @param param
 * @returns
 */
export const useReadAccountContactList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAccountContactList", searchData],
        queryFn: async () => await readAccountContactListApi(searchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
